module.exports = __webpack_public_path__ + "img/cases02-bg.9a7df3da.png";